import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { Table as Tables, TextField, withStyles } from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import EnhancedTableHead from "../../../../components/EnhancedTableHead";
// import { CheckBox } from '../../../components/CheckBox';
import RoundButton from "../../../../components/RoundButton";
import { DatePicker } from "../../../../components/DatePicker";
import { FilterFilled } from "@ant-design/icons";
import { Button, Input, Space, Table } from "antd";
import Highlighter from "react-highlight-words";
import { useNavigate } from "react-router-dom";
import { editFixedContracts, fixedContracts } from "../../../../apis";
import Snackbar from "../../../../components/Snackbar";
import _ from "lodash";
import useToken from "../../../../hooks/useToken";
import CheckIcon from "@material-ui/icons/Check";
import { Fab as FabButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { colors } from "../../../../constants/colors";
import { ComboBox } from "../../../../components/Autocomplete";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker as YearDatepicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';

const columns = [
  { align: "center", width: 70, type: "", id: "no", label: "Sr No." },
  {
    align: "left",
    width: 150,
    type: "text",
    id: "contract",
    label: "Contract No.",
  },
  {
    align: "left",
    width: 150,
    type: "date",
    id: "contractdate",
    label: "Contract Date",
  },
  {
    align: "left",
    width: 150,
    type: "text",
    id: "vendorname",
    label: "vendorname",
  },
  {
    align: "left",
    width: 150,
    type: "text",
    id: "gc_itemname",
    label: "Green Coffee Type",
  },
  // { align: "left", width: 150, type: "text", id: "shipper", label: "Shipper" },
  {
    align: "left",
    width: 150,
    type: "date",
    id: "dispatch_date",
    label: "Dispatch Date",
  },
  // {
  //   align: "left",
  //   width: 150,
  //   type: "text",
  //   id: "purchaseType",
  //   label: "Purchase Type",
  // },
  {
    align: "left",
    width: 150,
    type: "text",
    id: "quantity",
    label: "Quantity",
  },
  // {
  //   align: "left",
  //   width: 150,
  //   type: "month",
  //   id: "terminal_month",
  //   label: "Terminal Month",
  // },
  {
    align: "left",
    width: 150,
    type: "text",
    id: "booked_terminal_rate",
    label: "Booked Terminal Rate",
  },
  {
    align: "left",
    width: 150,
    type: "text",
    id: "FixedRate",
    label: "Fixed Terminal Rate",
  },
  {
    align: "left",
    width: 150,
    type: "month",
    id: "booked_terminal_month",
    label: "Booked Terminal Month",
  },
  {
    align: "left",
    width: 150,
    type: "month",
    id: "fixed_terminal_month",
    label: "Fixed Terminal Month",
  },
  {
    align: "left",
    width: 150,
    type: "date",
    id: "fixation_date",
    label: "Fixation Date",
  },
  {
    align: "left",
    width: 150,
    type: "text",
    id: "market_price",
    label: "Market Price",
  },
  // {
  //   align: "left",
  //   width: 150,
  //   type: "text",
  //   id: "comments",
  //   label: "Comment",
  // },
  { align: "left", width: 100, type: "text", id: "note", label: "Add Note" },
  { align: "left", width: 100, type: "text", id: "action", label: "Action" },
];

// const formatDate = (datestr) => {
//     let dateVal = datestr ? new Date(datestr): '';
//     return datestr ? dateVal.getDate() + "/" + (dateVal.getMonth() + 1) + "/" + dateVal.getFullYear() : '';
// }

// function createData(id, itemcode, s_code, itemname, category_name, uom, groupname, display_inpo, coffee_type, rm, createdby, createdon, lastupdatedby, lastupdatedon) {
//     return { id, itemcode, s_code, itemname, category_name, uom, groupname, display_inpo, coffee_type, rm, createdby, createdon, lastupdatedby, lastupdatedon };
// }

const useStyles = makeStyles({
  root: {
    width: "100%",
    marginTop: 24,
  },
  container: {
    maxHeight: 440,
  },
  sortHeader: {
    cursor: "pointer",
  },
  tableCell: {
    padding: "5px",
  },
});

const currentDate = () => {
  // 2019-07-25 17:31:46.967
  var dateVal = new Date();
  return (
    dateVal.getFullYear() +
    "-" +
    (dateVal.getMonth() + 1) +
    "-" +
    dateVal.getDate() +
    " " +
    dateVal.getHours() +
    ":" +
    dateVal.getMinutes() +
    ":" +
    dateVal.getSeconds()
  );
};

const formatDate = (date) => {
  // 2019-07-25 17:31:46.967
  var dateVal = new Date(date);
  return date === ""
    ? ""
    : dateVal.getDate() +
        "/" +
        (dateVal.getMonth() + 1) +
        "/" +
        dateVal.getFullYear();
};

const formatDateMonth = (date) => {
  // 2019-07-25 17:31:46.967
  var dateVal = new Date(date);
  return date === ""
    ? ""
    : dateVal.getMonth() + 1 + "/" + dateVal.getFullYear();
};

const StyledTableContainer = withStyles((theme) => ({
  root: {
    width: "100%",
  },
}))(TableContainer);

const ContractReportsList = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { getCurrentUserDetails } = useToken();
  const currentUserDetails = getCurrentUserDetails();
  const currentUserId = currentUserDetails.id;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(
    localStorage.getItem("RowsPerPage")
      ? localStorage.getItem("RowsPerPage")
      : 25
  );
  const [allData, setAllData] = useState([]);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("");
  const [editId, setEditId] = React.useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [validationError, setValidationError] = useState({});
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const [showSnack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData(props.data);
  }, [props.data]);

  function fetchData(data) {
    let rows = [];
    console.log("datarows::", data);
    // eslint-disable-next-line
    data &&
      data !== null &&
      data.map((v) => {
        rows.push({
          no: v.pono,
          contract: v.contract_no,
          contractdate: v.contractdate,
          vendorname: v.vendorname,
          gc_itemname: v.gc_itemname,
          // shipper: v.shipper_name,
          dispatch_date: v.dispatch_date,
          purchaseType: v.purchase_type,
          quantity: v.quantity,
          terminal_month: v.terminal_month,
          booked_terminal_rate: v.booked_terminal_rate,
          FixedRate: v.fixed_terminal_rate,
          booked_terminal_month: v.booked_terminal_month,
          differential: v.differential,
          fixed_terminal_month: v.fixed_terminal_month,
          fixation_date: v.fixation_date,
          market_price: v.market_price,
          action: "Action",
        });
      });
    console.log("rows::", rows);
    setAllData(rows);
  }

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<FilterFilled />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <FilterFilled
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const antColumns = [
    {
      key: "no",
      dataIndex: "no",
      title: "Sr No.",
      ...getColumnSearchProps("no"),
      width: "3%",
    },
    {
      key: "contract",
      dataIndex: "contract",
      title: "Contract No.",
      ...getColumnSearchProps("contract"),
      width: "4%",
      // render: (text, record) => {
      //   if (editId.findIndex(val => val === record.no) !== -1) {
      //     return (
      //       <TextField
      //         type="input"
      //         label="Contract No."
      //         variant="outlined"
      //         value={record.contract}
      //         onChange={(e) =>
      //           changeData(
      //             e.target.value,
      //             "contract",
      //             record,
      //             record.no
      //           )
      //         }
      //       />
      //     );
      //   } else {
      //     return <p>{record.contract}</p>;
      //   }
      // },
    },
    {
      key: "contractdate",
      dataIndex: "contractdate",
      title: "Contract Date",
      ...getColumnSearchProps("contractdate"),
      width: "3%",
      render: (text, record) => {
        return <p>{formatDate(record.contractdate) || ""}</p>;
      },
      // render: (text, record) => {
      //   if (editId.findIndex(val => val === record.no) !== -1) {
      //     return (
      //       <DatePicker
      //         label="Contract Date"
      //         value={record.contractdate}
      //         onChange={(e) =>
      //           changeData(
      //             e,
      //             "contractdate",
      //             record,
      //             record.no
      //           )
      //         }
      //       />
      //     );
      //   } else {
      //     return <p>{formatDate(record.contractdate)}</p>;
      //   }
      // },
    },
    {
      key: "vendorname",
      dataIndex: "vendorname",
      title: "vendorname",
      ...getColumnSearchProps("vendorname"),
      width: "6%",
      // render: (text, record) => {
      //   if (editId.findIndex(val => val === record.no) !== -1) {
      //     return (
      //       <TextField
      //         type="input"
      //         label="vendorname"
      //         variant="outlined"
      //         value={record.vendorname}
      //         onChange={(e) =>
      //           changeData(
      //             e.target.value,
      //             "vendorname",
      //             record,
      //             record.no
      //           )
      //         }
      //       />
      //     );
      //   } else {
      //     return <p>{record.vendorname}</p>;
      //   }
      // },
    },
    {
      key: "gc_itemname",
      dataIndex: "gc_itemname",
      title: "Green Coffee Type",
      ...getColumnSearchProps("gc_itemname"),
      width: "5.8%",
      // render: (text, record) => {
      //   if (editId.findIndex(val => val === record.no) !== -1) {
      //     return (
      //       <TextField
      //         type="input"
      //         label="Green Coffee Type"
      //         variant="outlined"
      //         value={record.gc_itemname}
      //         onChange={(e) =>
      //           changeData(
      //             e.target.value,
      //             "gc_itemname",
      //             record,
      //             record.no
      //           )
      //         }
      //       />
      //     );
      //   } else {
      //     return <p>{record.gc_itemname} </p>;
      //   }
      // },
    },
    // {
    //   key: "shipper",
    //   dataIndex: "shipper",
    //   title: "Shipper",
    //   ...getColumnSearchProps("shipper"),
    //   width: "4%",
    //   // render: (text, record) => {
    //   //   if (editId.findIndex(val => val === record.no) !== -1) {
    //   //     return (
    //   //       <TextField
    //   //         type="input"
    //   //         label="Shipper"
    //   //         variant="outlined"
    //   //         value={record.shipper}
    //   //         onChange={(e) =>
    //   //           changeData(e.target.value, "shipper", record, record.no)
    //   //         }
    //   //       />
    //   //     );
    //   //   } else {
    //   //     return <p>{record.shipper}</p>;
    //   //   }
    //   // },
    // },
    {
      key: "dispatch_date",
      dataIndex: "dispatch_date",
      title: "Dispatch Date",
      ...getColumnSearchProps("dispatch_date"),
      width: "4%",
      render: (text, record) => {
        return <p>{formatDate(record.dispatch_date)}</p>;
      },
      // render: (text, record) => {
      //   if (editId.findIndex(val => val === record.no) !== -1) {
      //     return (
      //       <DatePicker
      //         label="Dispatch Date"
      //         value={record.dispatch_date}
      //         onChange={(e) =>
      //           changeData(
      //             e,
      //             "dispatch_date",
      //             record,
      //             record.no
      //           )
      //         }
      //       />
      //     );
      //   } else {
      //     return <p>{formatDate(record.dispatch_date)}</p>;
      //   }
      // },
    },
    // {
    //   key: "purchaseType",
    //   dataIndex: "purchaseType",
    //   title: "Purchase Type",
    //   ...getColumnSearchProps("purchaseType"),
    //   width: "5.8%",
    //   // render: (text, record) => {
    //   //   if (editId.findIndex(val => val === record.no) !== -1) {
    //   //     return (
    //   //       <TextField
    //   //         type="input"
    //   //         label="Purchase Type"
    //   //         variant="outlined"
    //   //         value={record.purchaseType}
    //   //         onChange={(e) =>
    //   //           changeData(
    //   //             e.target.value,
    //   //             "purchaseType",
    //   //             record,
    //   //             record.no
    //   //           )
    //   //         }
    //   //       />
    //   //     );
    //   //   } else {
    //   //     return <p>{record.purchaseType}</p>;
    //   //   }
    //   // },
    // },
    {
      key: "quantity",
      dataIndex: "quantity",
      title: "Quantity",
      ...getColumnSearchProps("quantity"),
      width: "4%",
      render: (text, record) => {
        // if (editId.findIndex(val => val === record.no) !== -1) {
        //   return (
        //     <TextField
        //       type="input"
        //       label="Quantity"
        //       variant="outlined"
        //       value={record.quantity}
        //       onChange={(e) =>
        //         changeData(
        //           e.target.value,
        //           "quantity",
        //           record,
        //           record.no
        //         )
        //       }
        //     />
        //   );
        // } else {
        return <p>{record.quantity}</p>;
        // }
      },
    },
    // {
    //   key: "terminal_month",
    //   dataIndex: "terminal_month",
    //   title: "Terminal Month",
    //   ...getColumnSearchProps("terminal_month"),
    //   width: "6%",
    //   render: (text, record) => {
    //     if (editId.findIndex(val => val === record.no) !== -1) {
    //       return (
    //         <DatePicker
    //           format="MM/yyyy"
    //           views={["year", "month"]}
    //           label="Terminal Month"
    //           value={record.terminal_month === '' ? null : record.terminal_month}
    //           onChange={(e) =>
    //             changeData(
    //               e,
    //               "terminal_month",
    //               record,
    //               record.no
    //             )
    //           }
    //         />
    //       );
    //     } else {
    //       return <p>{formatDateMonth(record.terminal_month)}</p>;
    //     }
    //   },
    // },
    {
      key: "booked_terminal_rate",
      dataIndex: "booked_terminal_rate",
      title: "Booked Terminal Rate",
      ...getColumnSearchProps("booked_terminal_rate"),
      width: "6%",
      render: (text, record) => {
        // if (editId.findIndex(val => val === record.no) !== -1) {
        //   return (
        //     <TextField
        //       type="input"
        //       label="Booked Terminal Rate"
        //       variant="outlined"
        //       value={record.booked_terminal_rate}
        //       onChange={(e) =>
        //         changeData(
        //           e.target.value,
        //           "booked_terminal_rate",
        //           record,
        //           record.no
        //         )
        //       }
        //     />
        //   );
        // } else {
        return <p>{record.booked_terminal_rate}</p>;
        // }
      },
    },
    {
      key: "FixedRate",
      dataIndex: "FixedRate",
      title: "Fixed Terminal Rate",
      ...getColumnSearchProps("FixedRate"),
      width: "6%",
      render: (text, record) => {
        if (editId.findIndex((val) => val === record.no) !== -1) {
          return (
            <TextField
              type="input"
              label="Fixed Terminal Rate"
              variant="outlined"
              value={record.FixedRate}
              error={validationError?.FixedRate}
              helperText={validationError?.FixedRate}
              onChange={(e) =>
                changeData(e.target.value, "FixedRate", record, record.no)
              }
            />
          );
        } else {
          return <p>{record.FixedRate}</p>;
        }
      },
    },
    {
      key: "booked_terminal_month",
      dataIndex: "booked_terminal_month",
      title: "Booked Terminal Month",
      ...getColumnSearchProps("booked_terminal_month"),
      width: "6%",
      render: (text, record) => {
        // if (editId.findIndex(val => val === record.no) !== -1) {
        //   return (
        //     <DatePicker
        //       format="MM/yyyy"
        //       views={["year", "month"]}
        //       label="Booked Terminal Month"
        //       value={record.booked_terminal_month === '' ? null : record.booked_terminal_month}
        //       onChange={(e) =>
        //         changeData(
        //           e,
        //           "booked_terminal_month",
        //           record,
        //           record.no
        //         )
        //       }
        //     />
        //   );
        // } else {
        return <p>{formatDateMonth(record.booked_terminal_month)}</p>;
        // }
      },
    },
    {
      key: "differential",
      dataIndex: "differential",
      title: "Differential",
      ...getColumnSearchProps("differential"),
      width: "6%",
      render: (text, record) => {
        // if (editId.findIndex(val => val === record.no) !== -1) {
        //   return (
        //     <DatePicker
        //       format="MM/yyyy"
        //       views={["year", "month"]}
        //       label="Booked Terminal Month"
        //       value={record.booked_terminal_month === '' ? null : record.booked_terminal_month}
        //       onChange={(e) =>
        //         changeData(
        //           e,
        //           "booked_terminal_month",
        //           record,
        //           record.no
        //         )
        //       }
        //     />
        //   );
        // } else {
        return <p>{record.differential}</p>;
        // }
      },
    },
    {
      key: "fixed_terminal_month",
      dataIndex: "fixed_terminal_month",
      title: "Fixed Terminal Month",
      ...getColumnSearchProps("fixed_terminal_month"),
      width: "6%",
      render: (text, record) => {
        if (editId.findIndex((val) => val === record.no) !== -1) {
          return (
            <DatePicker
              format="MM/yyyy"
              views={["year", "month"]}
              label="Fixed Terminal Month"
              value={
                record.fixed_terminal_month === ""
                  ? null
                  : record.fixed_terminal_month
              }
              error={validationError?.fixed_terminal_month}
              helperText={validationError?.fixed_terminal_month}
              onChange={(e) =>
                changeData(e, "fixed_terminal_month", record, record.no)
              }
            />
          );
        } else {
          return <p>{formatDateMonth(record.fixed_terminal_month)}</p>;
        }
      },
    },
    {
      key: "fixation_date",
      dataIndex: "fixation_date",
      title: "Fixation Date",
      ...getColumnSearchProps("fixation_date"),
      width: "8%",
      render: (text, record) => {
        if (editId.findIndex((val) => val === record.no) !== -1) {
        
            // <DatePicker
            //   label="Fixation Date"
            //   value={record.fixation_date === "" ? null : record.fixation_date}
            //   error={validationError?.fixation_date}
            //   helperText={validationError?.fixation_date}
            //   onChange={(e) =>
            //     changeData(e, "fixation_date", record, record.no)
            //   }
            // />
            return (
              <LocalizationProvider dateAdapter={AdapterDayjs} className='yeardate1' sx={{width: '100%'}} >
              <DemoContainer components={["DatePicker"]}className='yeardate2' sx={{width: '100%'}}>
                <YearDatepicker onChange={(e) => changeData(e, "fixation_date", record, record.no)} renderInput={{readOnly: true}} closeOnSelect={true} value={dayjs(record.fixation_date === "" ? null : record.fixation_date)} views={['year', 'month', 'day']} className='yeardate3' format={'DD/MM/YYYY'}  label="Fixation Date"  error={validationError?.fixation_date}  helperText={validationError?.fixation_date}  />
              </DemoContainer>
            </LocalizationProvider>
            );
        } else {
          return <p>{formatDate(record.fixation_date)}</p>;
        }
      },
    },
    {
      key: "market_price",
      dataIndex: "market_price",
      title: "Market Price",
      ...getColumnSearchProps("market_price"),
      width: "4%",
      render: (text, record) => {
        // if (editId.findIndex(val => val === record.no) !== -1) {
        //   return (
        //     <TextField
        //       type="input"
        //       label="Market Price"
        //       variant="outlined"
        //       value={record.market_price}
        //       onChange={(e) =>
        //         changeData(
        //           e.target.value,
        //           "market_price",
        //           record,
        //           record.no
        //         )
        //       }
        //     />
        //   );
        // } else {
        return <p>{record.market_price}</p>;
        // }
      },
    },
    // {
    //   key: "comment",
    //   dataIndex: "comment",
    //   title: "Comment",
    //   ...getColumnSearchProps("comment"),
    //   width: "4%",
    //   render: (text, record) => {
    //       return <p>{record.market_price}</p>;
    //   },
    // },
    {
      key: "action",
      dataIndex: "action",
      title: "Action",
      ...getColumnSearchProps("action"),
      width: "6%",
      render: (text, record) => {
        if (editId.findIndex((val) => val === record.no) === -1) {
          return (
            <RoundButton
              onClick={() => onEditClick(record, "edit")}
              label={"Edit"}
            />
          );
        } else {
          return (
            <>
              <FabButton onClick={() => onEditClick(record, "save")} style={{backgroundColor: colors.orange,color: colors.white,height:"50px",width:"50px",marginRight:"15px",marginLeft:"18px"}}>
                <CheckIcon />
              </FabButton>
              <FabButton onClick={() => onEditClick(record, "cancel")}style={{backgroundColor: colors.orange,color: colors.white,height:"50px",width:"50px",marginRight:"15px"}}>
                <CloseIcon />
              </FabButton>

              {/* // <RoundButton
            //   onClick={() => onEditClick(record, "save")}
            //   label={"Save"}
            // /> */}
            </>
          );
        }
      },
    },
    {
      key: "note",
      dataIndex: "note",
      title: "Add Note",
      ...getColumnSearchProps("note"),
      width: "6%",
      render: (text, record) => {
        // if (editId.findIndex(val => val === record.no) === -1) {
        return (
          <RoundButton
            onClick={() =>
              navigate(`/purchase-order/${record.no.replaceAll('/', '%2F')}/view?tab=notes`)
            }
            label={"Add Note"}
          />
        );
        // }
      },
    },
  ];

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    localStorage.setItem("RowsPerPage", +event.target.value);
    setPage(0);
  };

  // const action = (e, index, gcId) => {
  //   e.preventDefault();
  //   if(index === 0) {
  //       props.gcDetails("create_gc_edit", gcId);
  //   }
  //   return false;
  // }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  function handleAdvancedFilter(val) {
    props.selectedAdvancedFilters(val);
    setPage(0);
  }

  async function onEditClick(row, type) {
    let temp = [...editId];
    if (type === "edit") {
      temp.push(row.no);
    } else if (type === "cancel") {
      temp = editId.filter((val) => val !== row.no);
      try {
        let response = await fixedContracts({
          filter: null,
          loggedinuserid: currentUserId,
        });
        if (response) {
          fetchData(response);
        }
      } catch (e) {
        setSnack({
          open: true,
          message: "Server Error. Please contact administrator", //e.response?.data
          severity: "error",
        });
      }
    } else {
      const message = "Please enter valid details";
      let errorObj = {};
      // if (
      //   !_.isEmpty(row.FixedRate) &&
      //   (row.fixed_terminal_month === "" ||
      //     row.fixed_terminal_month === null) &&
      //   (row.fixation_date === "" || row.fixation_date === null)
      // ) {
      //   console.log('errorobject1',errorObj)
      //   errorObj = {
      //     ...errorObj,
      //     fixed_terminal_month: message,
      //     fixation_date: message,
      //   };
      // } else if (
      //   _.isEmpty(row.FixedRate) &&
      //   (
      //     row.fixed_terminal_month !== "" || row.fixed_terminal_month !== null
      //   ) &&
      //   (row.fixation_date === "" || row.fixation_date === null)
      // ) 
     
      // {
      //   console.log('errorobject2',errorObj)
      //   errorObj = { ...errorObj, FixedRate: message, fixation_date: message };
      // } else if (
      //   _.isEmpty(row.FixedRate) &&
      //   (row.fixed_terminal_month === "" ||
      //     row.fixed_terminal_month === null) &&
      //   (row.fixation_date !== "" || row.fixation_date !== null)
      // ) {
      //   console.log('errorobject3',errorObj)
      //   errorObj = {
      //     ...errorObj,
      //     FixedRate: message,
      //     fixed_terminal_month: message,
      //   };
      // } else if (
      //   _.isEmpty(row.FixedRate) &&
      //   !(
      //     row.fixed_terminal_month === "" || row.fixed_terminal_month === null
      //   ) &&
      //   (row.fixation_date !== "" || row.fixation_date !== null)
      // ) {
      //   console.log('errorobject4',errorObj)
      //   errorObj = { ...errorObj, FixedRate: message };
      // } else if (
      //   !_.isEmpty(row.FixedRate) &&
      //   (
      //     row.fixed_terminal_month !== "" || row.fixed_terminal_month !== null
      //   ) &&
      //   (row.fixation_date === "" || row.fixation_date === null)
      // ) {
      //   console.log('errorobject5',errorObj)
      //   errorObj = { ...errorObj, fixation_date: message };
      // } else if (
      //   !_.isEmpty(row.FixedRate) &&
      //   (row.fixed_terminal_month === "" ||
      //     row.fixed_terminal_month === null) &&
      //   !(row.fixation_date === "" || row.fixation_date === null)
      // ) {
      //   console.log('errorobject6',errorObj)
      //   errorObj = { ...errorObj, fixed_terminal_month: message };
      // } else if (
      //   !_.isEmpty(row.FixedRate) &&
      //   !(
      //     row.fixed_terminal_month === "" || row.fixed_terminal_month === null
      //   ) &&
      //   !(row.fixation_date === "" || row.fixation_date === null)
      // ) {
      //   delete errorObj.fixed_terminal_month;
      //   delete errorObj.fixation_date;
      //   delete errorObj.FixedRate;
      // } else {
      //   delete errorObj.fixed_terminal_month;
      //   delete errorObj.fixation_date;
      //   delete errorObj.FixedRate;
      // }
      if(row.FixedRate === '' || row.FixedRate === null || parseInt(row.FixedRate) === 0) {
        errorObj = { ...errorObj, FixedRate: message };
      }
      if(row.fixed_terminal_month === '' || row.fixed_terminal_month === null) {
        errorObj = { ...errorObj, fixed_terminal_month: message };
      }
      if(row.fixation_date === '' || row.fixation_date === null) {
        errorObj = { ...errorObj, fixation_date: message };
      }

      console.log(
        "editdata::",
        errorObj,
        row,
        !_.isEmpty(errorObj)
      );
      if (!_.isEmpty(errorObj)) {
        setValidationError(errorObj);
      } else {
        temp = editId.filter((val) => val !== row.no);
        let purchaseprice = (parseFloat(row.FixedRate) + parseFloat(row.differential ? row.differential : 0));
        const market_price = row.market_price ? parseFloat(row.market_price) : 0;
        let data = {
          // terminal_month: row.terminal_month,
          fixed_terminal_rate: row.FixedRate,
          fixed_terminal_month: row.fixed_terminal_month,
          fixation_date: row.fixation_date,
          market_price: row.market_price,
          purchase_price: purchaseprice.toString(),
          grossPrice: ((parseFloat(purchaseprice) * Number(row.quantity))/1000),
          po_margin: parseFloat(market_price - parseFloat(purchaseprice)),  
          pono: row.no,
          rate:((parseFloat(purchaseprice))/1000),
        };
        console.log('row::', row, data);
        // return;

        try {
          let response = await editFixedContracts(data);
          if (response) {
            setSnack({
              open: true,
              message: "Fixed Contract Record Saved Successfully",
            });
          }
        } catch (e) {
          setSnack({
            open: true,
            message: "Server Error. Please contact administrator", //e.response?.data
            severity: "error",
          });
        } finally {
          // setLoading(false);
        }

        try {
          let response = await fixedContracts({
            filter: null,
            loggedinuserid: currentUserId,
          });
          if (response) {
            fetchData(response);
          }
        } catch (e) {
          setSnack({
            open: true,
            message: "Server Error. Please contact administrator", //e.response?.data
            severity: "error",
          });
        }
      }
    }
    setEditId(temp);
  }

  function changeData(val, id, data, index) {
    console.log("change::", val, id, data, index, allData);
    let temp = [...allData];
    // temp[index - 1][id] = val;
    temp.map((item) => {
      if (item.no === index) {
        item[id] = val;
      }
    });
    setAllData(temp);
  }

  return (
    <>
      {showSnack.open && (
        <Snackbar
          {...showSnack}
          handleClose={() =>
            setSnack({ open: false, message: "", severity: "" })
          }
        />
      )}
      <Paper className={classes.root}>
        <TableContainer className={classes.container}>
          {/* <Table columns={antColumns} dataSource={allData} /> */}

          <TableContainer
            className={classes.container}
            style={{ display: "none" }}
          ></TableContainer>
          <Table
            columns={antColumns}
            dataSource={allData}
            scroll={{ x: 1500, y: 300 }}
          />
        </TableContainer>

        <TableContainer
          className={classes.container}
          style={{ display: "none" }}
        >
          <Tables stickyHeader aria-label="sticky table" size="small">
            <EnhancedTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={allData.length}
              headCells={columns}
              selectedAdvancedFilters={props.selectedAdvancedFilters}
              clearAdvancedFilters={props.clearAdvancedFilters}
            />
            <TableBody>
              {allData.length > 0
                ? stableSort(allData, getComparator(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, i) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.code}
                        >
                          {columns.map((column, index) => {
                            const value = row[column.id] ? row[column.id] : "-";
                            if (editId !== row.no) {
                              return (
                                <TableCell
                                  key={column.id}
                                  align={column.align}
                                  className={classes.tableCell}
                                  style={{
                                    padding: "5px",
                                    width: column.width,
                                  }}
                                >
                                  {column.id === "action" ? (
                                    <>
                                      <RoundButton
                                        onClick={() => onEditClick(row, "edit")}
                                        label={"Edit"}
                                      />
                                    </>
                                  ) : column.type === "date" ? (
                                    formatDate(value)
                                  ) : column.type === "month" ? (
                                    formatDateMonth(value)
                                  ) : (
                                    value
                                  )}
                                </TableCell>
                              );
                            } else {
                              return (
                                <TableCell
                                  key={column.id}
                                  align={column.align}
                                  width={column.width}
                                  className={classes.tableCell}
                                  style={{
                                    padding: "5px",
                                    width: column.width,
                                  }}
                                >
                                  {column.id === "action" ? (
                                    <RoundButton
                                      onClick={() => onEditClick(row, "save")}
                                      label={"Save"}
                                    />
                                  ) : column.type === "" ? (
                                    value
                                  ) : column.type === "date" ? (
                                    <DatePicker
                                      label={column.label}
                                      onChange={(e) =>
                                        changeData(e, column.id, row, i)
                                      }
                                      value={value}
                                    />
                                  ) : column.type === "month" ? (
                                    <DatePicker
                                      label={column.label}
                                      format="MM/yyyy"
                                      value={value}
                                      views={["year", "month"]}
                                      onChange={(e) =>
                                        changeData(e, column.id, row, i)
                                      }
                                    />
                                  ) : (
                                    <TextField
                                      type="input"
                                      label={column.label}
                                      variant="outlined"
                                      value={value}
                                      onChange={(e) =>
                                        changeData(
                                          e.target.value,
                                          column.id,
                                          row,
                                          i
                                        )
                                      }
                                    />
                                  )}
                                </TableCell>
                              );
                            }
                          })}
                        </TableRow>
                      );
                    })
                : "No records to display"}
            </TableBody>
          </Tables>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[25, 100]}
          component="div"
          count={allData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          style={{ display: "none" }}
        />
      </Paper>
    </>
  );
};

export default ContractReportsList;